export enum UserRole {
  ADMIN = 'Admin',
  APPROVER = 'Approver',
  ORDER_CLEARER = 'Order Clearer',
  PAYMENT_CLEARER = 'Payment Clearer',
  PURCHASER = 'Purchaser',
  PAYER = 'Payer',
}
